module.exports = __webpack_public_path__ + "static/media/Jara_Zeitraffer_KBA40_vs_KMBM_V1_2.34f35c0d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/jara/images/Jara_Zeitraffer_KBA40_vs_KMBM_V1_2.mp4
// module id = 574
// module chunks = 0